import { render } from "./Tasks.vue?vue&type=template&id=2eeb6776"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"
script.render = render

export default script